import * as React from 'react'
import { AsyncState, fromJSX, nothing, Widget } from 'widgets-for-react'
import { UserSubscriptions } from '../../../subscription/subscriptionState'
import { CurrentPage } from '../../../utils/routes'
import { Pages } from '../routes/routesState'
import { BannerLayout } from './bannerLayout'

export const signupSuccessBannerWidget = <A,>(
  page: CurrentPage<Pages>,
  userSubscriptions: AsyncState<UserSubscriptions>
): Widget<A> =>
  (page.kind === 'home' ||
    page.kind == 'blogOverview' ||
    page.kind == 'blogDetail' ||
    page.kind == 'dishesDetail' ||
    page.kind == 'componentDetail' ||
    page.kind == 'componentOverview' ||
    page.kind == 'search' ||
    page.kind == 'knowledgeOverview' ||
    page.kind == 'knowledgeTypeOverview' ||
    page.kind == 'knowledgeDetail' ||
    page.kind == 'seasonalCalendar') &&
  page.params['signup-success'] == 'true' &&
  userSubscriptions.kind == 'loaded'
    ? fromJSX(() => (
        <BannerLayout
          kind="signup-success"
          trialDaysLeft={Math.ceil(userSubscriptions.value.TrialDaysLeft)}
        />
      ))
    : nothing()

export const componentBannerWidget = <A,>(
  kind: 'premium' | 'public-register' | 'public-subscribe'
): Widget<A> =>
    fromJSX(() => (
      <>
        <BannerLayout kind={kind} />
      </>
  ))
